import TopBar from "../components/TopBar";
import { Box, Typography, useTheme, TextField, Button } from "@mui/material";
import { tokens } from "../theme";
import { useRef, useState, useEffect} from "react";

import { useAuth } from "../components/AuthProvider";
import api from "../utils/api";

import FileUpload from "../components/FileUpload";
import { getImageUrl } from "../utils/apiHelpers";

import SaveIcon from '@mui/icons-material/SaveAlt';
import RegexValidatedTextField from "../components/RegexValidatedTextField";

import styles from './Profile.module.css'; 

import React from 'react'

export default function Profile() {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [menuOpen, setMenuOpen] = React.useState(false);

    const { user, setTokenAndUser } = useAuth();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);

    const [fieldValues, setFieldValues] = useState(null)

    useEffect(() => {
        if (user) {
            setFieldValues({
                display_name: user.display_name,
                new_password: '',
                old_password: '',
                profile_image_path: user.profile_image_path,
                password: null,
            });
            setLoading(false);
        }
    }, [user]);

    // Contains bool determining if the input fields are valid
    const [validity, setValidity] = useState({
        new_password: true,
        display_name: true
    });

    const nameRegex = new RegExp("^.{0,255}$");

    /**
    * Uses the values in fieldValues and file to first upload the image to the server
    * and get its path. Then a post request is created to edit the user in the database
    * with filepath from file, and username, display_name and password from fieldValues.
    * @param {event} e 
    */
    async function handleEditingUser(e) {
        e.preventDefault();

        let updatedFields = {};

        try {
            if (fieldValues.new_password !== "") {
                const res = await api.post('/verify_password', {
                    name: user.name,
                    old_password: fieldValues.old_password
                }, { withCredentials: true });

                if (res.status !== 200) {
                    setError("Incorrect password");
                    return; // Stop execution if password isn't verified
                }

                updatedFields.password = fieldValues.new_password;
            }
            console.log(updatedFields)

            if (file != null) {
                const formData = new FormData();
                formData.append('image', file);

                // Upload file to server as image
                const res = await api.post('/upload_image', formData);
                const path = "images/" + res.data.filename;
                updatedFields.profile_image_path = path;
            }

            if (fieldValues.display_name != user.display_name) {
                updatedFields.display_name = fieldValues.display_name;
            }

            // Create product from fieldValues and image path
            const message = await api.post(`/update_profile/${user.id}`, updatedFields);
            console.log(message)

            setMenuOpen(true)

            setTimeout(() => {
                setMenuOpen(false);
            }, 3000);

            // Get a new access token (assuming you use cookies for refresh token)
            const res = await api.get('/refreshToken', { withCredentials: true });
            
            if (res.data.accessToken) {
                setTokenAndUser(res.data.accessToken);
            }

            // Reset variables
            setFile(undefined);
            if (fileInputRef.current) {
                fileInputRef.current.value = ""; // Reset the file input
            }
        } catch (err) {
            if (err.response && err.response.status === 401) {
                setError("Incorrect password");
            } else {
                console.error("Unhandled error:", err);
            }
        }
    }


    const [file, setFile] = useState();
    const fileInputRef = useRef();

    return (
        <div>
            <TopBar/>
            <Typography
            variant="h2"
            color={colors.ceriseAccent[900]}
            fontWeight="medium" 
            sx={{m : "50px 0 10px 30px" }}
            >
            Redigera profil
            </Typography>
            <Box display="flex" flexDirection="column" alignItems="flex-start" justifyContent="center" sx={{m: "0 0 0 30px"}}>
                {
                    !loading ? <div>
                {/* Profile picture file input field */}
                <Box display="flex" flexDirection="column" gap="10px" sx={{m: "0 0 10px 0"}}>
                    <FileUpload initialImage={user.profile_image_path} file={file} setFile={setFile} fileInputRef={fileInputRef} />
                </Box>
                <TextField
                    label="Användarnamn"
                    disabled
                    variant="outlined"
                    value={user !== null ? user.name : ""}
                    sx={{m: "10px 0 0 0", width: "90%"}}
                    >
                </TextField>
                <RegexValidatedTextField
                    label="Visningsnamn"
                    variant="outlined"
                    regex={nameRegex}
                    value={fieldValues.display_name}
                    errorMessage="Visningsnamn kan max vara 255 tecken"
                    onValidChange={(value, isValid) => {
                        setFieldValues({...fieldValues, display_name: value})
                        setValidity(prev => ({...prev, display_name: isValid}));
                    }}
                    sx={{m: "10px 0 0 0", width: "90%"}}
                    >
                </RegexValidatedTextField>

                {/* New password field, invalid if its filled but current password isn't */}
                <TextField
                    label="Nytt lösenord"
                    variant="outlined"
                    type="password"
                    value={fieldValues.new_password}
                    error={!validity.new_password}
                    helperText={!validity.new_password ? "Fyll i ditt nuvarande lösenord nedan" : ""}
                    onChange={(e) => {
                        setFieldValues({ ...fieldValues, new_password: e.target.value });
                        setValidity(prev => ({
                            ...prev,
                            new_password:
                                (e.target.value !== "" && fieldValues.old_password !== "") ||
                                (e.target.value === "" && fieldValues.old_password === "")
                        }));
                    }}
                    sx={{m: "10px 0 0 0", width: "90%"}}
                    >
                </TextField>

                {/* Current password, needs to be filled if new password is */}
                <TextField
                    label="Nuvarande lösenord"
                    variant="outlined"
                    type="password"
                    disabled={fieldValues.new_password == ""}
                    value={fieldValues.old_password}
                    onChange={(e) => {
                        setFieldValues({ ...fieldValues, old_password: e.target.value });
                        setValidity(prev => ({
                            ...prev,
                            new_password:
                                (fieldValues.new_password !== "" && e.target.value !== "") ||
                                (fieldValues.new_password === "" && e.target.value === "")
                        }));
                    }}
                    sx={{m: "10px 0 10px 0", width: "90%"}}
                    >
                </TextField>
                </div>
                : null
                }
                <Button
                    variant="contained"
                    disabled={!validity.new_password}
                    onClick={handleEditingUser}
                    >
                    <SaveIcon/>
                    <Typography
                        variant="h6"
                        color={colors.gray[100]}
                        fontWeight="medium" 
                        sx={{m : "0 0 0px 10px"}}
                        >
                        Spara
                    </Typography>
                </Button>
                {
                    error ?
                    <Typography
                    variant="h6"
                    color={colors.redAccent[300]}
                    fontWeight="medium" 
                    sx={{m : "10px 0 0px 0px" }}
                    >
                    {error}
                    </Typography>
                    : null
                }
                {/* Announcement when profile is updated */}
                <Box className={`${styles.modal} ${menuOpen ? styles.modalOpen : ''}`}>
                    <Box display="flex" alignItems="center" justifyContent="center" padding="10px" sx={{bgcolor: colors.ceriseAccent[100], borderRadius: "4px"}}>
                        <Typography
                            variant="h4"
                            color={colors.gray[100]}
                            fontWeight="medium" 
                            >
                        Profil uppdaterad!
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </div>
    )
}
